var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoOld = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2403_3143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 9.77612C23.75 14.6044 23.2408 18.5467 13.0204 18.7875L8.65513 23.1821C7.94756 23.8944 6.73832 23.3894 6.73832 22.3831V18.3884C5.43924 18.1468 4.39847 17.8001 3.56735 17.367L5.3827 13.3268C5.76494 13.3076 6.1206 13.1983 6.43508 13.0211L8.23583 14.2159C8.22834 14.2988 8.2246 14.3821 8.2246 14.4646C8.2246 15.8176 9.31366 16.9144 10.658 16.9144C12.0021 16.9144 13.0915 15.8176 13.0915 14.4646C13.0915 13.8921 12.8931 13.3645 12.5674 12.9499L14.0387 9.65212C15.3153 9.58013 16.3299 8.51354 16.3299 7.2095C16.3299 5.85685 15.2404 4.75972 13.8964 4.75972C12.5524 4.75972 11.463 5.85685 11.463 7.2095C11.463 7.78237 11.6614 8.31002 11.9871 8.7246L10.5154 12.0224C10.1377 12.0454 9.78575 12.1509 9.47127 12.328L7.67052 11.1333C7.67801 11.0504 7.68175 10.9671 7.68175 10.8842C7.68175 9.53152 6.59232 8.43439 5.2483 8.43439C3.90429 8.43439 2.81485 9.53152 2.81485 10.8842C2.81485 11.4533 3.00953 11.9813 3.33524 12.3955L1.73665 15.9458C0.373919 14.3331 0.25 12.1618 0.25 9.77612C0.25 4.79025 0.793221 0.75 12.0021 0.75C23.2072 0.75 23.75 4.79025 23.75 9.77612Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2403_3143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoOld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LogoOld.8e6fe4f395dc821f407d98aa491f83af.svg";